<template>
  <div
    v-if="currentUser"
    class="mb-4"
  >
    <CustomerMemoTable
      ref="memoTable"
      @view:row="term => $refs.memoView.viewMemo(term)"
    />

    <CustomerMemoView
      ref="memoView"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import CustomerMemoTable from './components/CustomerMemoTable.vue'
import CustomerMemoView from './components/CustomerMemoView.vue'

import MxMisc from '@/mixins/misc'

export default {
  name: 'MkmCustomerMemosBase',

  components: {
    CustomerMemoTable,
    CustomerMemoView
  },

  mixins: [
    MxMisc
  ],

  middleware: [
    'auth',
    'mkm'
  ],

  metaInfo: () => ({
    title: 'Customer Memos'
  }),

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })
  }
}
</script>
